import React from "react";

import { useTranslation } from "next-i18next";
import Image from "next/image";

import { Box, Typography } from "@mui/material";

export const GallerySection = (props: any): JSX.Element => {
  const { t } = useTranslation("chefspage");
  return (
    <Box>
      <Typography
        mt={1.25}
        mb={2.5}
        fontSize={24}
        fontWeight={400}
        align={"center"}
        sx={{
          fontSize: { xs: 24, md: 48 },
          textAlign: { xs: "center", md: "start" },
          maxWidth: { md: "1180px" },
          width: { md: "100%" },
          margin: { md: "0 auto" }
        }}>
        {t("title")}
      </Typography>
      <Box height={{ xs: 190, sm: 600 }} display={"flex"} gap={1.25}>
        <Box flex={1} position={"relative"}>
          <Image
            alt={"image"}
            src={"/images/chefspage/image1.webp"}
            layout={"fill"}
            objectPosition={"center 20%"}
            objectFit={"cover"}
            width={634}
            height={600}
            quality={75}
            priority
          />
        </Box>
        <Box flex={1} position={"relative"}>
          <Image
            alt={"image"}
            src={"/images/chefspage/image2.webp"}
            layout={"fill"}
            objectFit={"cover"}
            width={634}
            height={600}
            quality={75}
            priority
          />
        </Box>
        <Box flex={1} position={"relative"}>
          <Image
            alt={"image"}
            src={"/images/chefspage/image3.webp"}
            layout={"fill"}
            objectFit={"cover"}
            width={634}
            height={600}
            quality={75}
            priority
          />
        </Box>
      </Box>
    </Box>
  );
};
